import { render } from "./Mock.vue?vue&type=template&id=1002f398&scoped=true"
import script from "./Mock.vue?vue&type=script&lang=js"
export * from "./Mock.vue?vue&type=script&lang=js"

import "./Mock.vue?vue&type=style&index=0&id=1002f398&lang=scss&scoped=true"
import "./Mock.vue?vue&type=style&index=1&id=1002f398&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1002f398"]])

export default __exports__